import React, { useReducer } from "react";

const AppContext = React.createContext({});

const initialState = { profile: null };

export const profileReducer = (state, action) => {
  switch (action.type) {
    case "SET":
      return {
        ...state,
        profile: {
          legalName: action.payload.legalName,
          nickname: action.payload.nickname,
          email: action.payload.email,
          projectCode: action.payload.projectCode,
        },
      };
    case "DEL":
      return null;
    default:
      return state;
  }
};

const AppProvider = ({ children }) => {
  const [state, dispatch] = useReducer(profileReducer, initialState);

  return (
    <AppContext.Provider value={{ state, dispatch }}>
      {children}
    </AppContext.Provider>
  );
};

export { AppContext, AppProvider };
